import { useEffect } from 'react';

import '@fontsource/vt323';
import supabaseClient from '../core/services/supabase/supabase.service';
import { useAuthStore } from '../core/zustand/store/authStore/authStore';
import { API } from '../shared/api';
import { useMutation } from '../shared/hooks';
import { IApp } from './App.config';
import './App.css';

const App = function ({ children }: IApp) {

  const { user, setUser, setAccessToken } =
    useAuthStore();

  const checkUser = async () => {
    const { count, error } = await supabaseClient
      .from('profiles')
      .select('*', { count: 'exact', head: true })
    if (!count || error) createUserProfile.mutate({});
  }

  const createUserProfile = useMutation(API.USER_PROFILE, {
    options: {
      onSuccess: () => {
        window.location.reload();
      },
    },
  });

  useEffect(() => {
    const fetchSession = async () => {
      const { data } = await supabaseClient.auth.getSession();
      if (data.session) {
        setUser(data.session.user);
        setAccessToken(data.session.access_token);
      }
    };
    fetchSession();
  }, [])

  useEffect(() => {
    const { data: listener } = supabaseClient.auth.onAuthStateChange(
      async (event, session) => {
        setUser(session?.user ?? null);
        setAccessToken(session?.access_token ?? null);

        if (event === 'SIGNED_IN') await checkUser();
      },
    );

    return () => {
      listener.subscription.unsubscribe();
    };
  }, [user]);

  return children;
};

export default App;
